export default {
  how_to_place_order: {
    header: 'Como faço uma encomenda?',
    body: 'Basta navegar no menu, adicionar itens ao carrinho e seguir os passos de pagamento. Receberá uma confirmação assim que a encomenda for realizada.',
  },
  schedule_order: {
    header: 'Posso agendar uma encomenda com antecedência?',
    body: 'Sim! No checkout, escolha a opção «Agendar» para definir um horário de recolha futuro que lhe seja conveniente.',
  },
  customize_order: {
    header: 'Posso personalizar a minha encomenda?',
    body: 'Claro. Toque num item do menu para ver as opções de personalização, como coberturas, acompanhamentos e preferências.',
  },
  track_order: {
    header: 'Como acompanho a minha encomenda?',
    body: 'Após realizar a encomenda, verá atualizações em tempo real na aplicação — desde a confirmação até à preparação e prontidão para recolha.',
  },
  cancel_or_edit_order: {
    header: 'Posso cancelar ou editar a minha encomenda após a realizar?',
    body: 'Se a sua encomenda ainda não começou a ser preparada, pode solicitar alterações ligando diretamente ao restaurante através da aplicação.',
  },
  payment_methods: {
    header: 'Que métodos de pagamento aceitam?',
    body: 'Aceitamos os principais cartões de crédito/débito, Apple Pay e Google Pay, conforme o seu dispositivo.',
  },
  no_confirmation: {
    header: 'Não recebi uma confirmação. O que devo fazer?',
    body: 'Verifique a pasta de spam do seu email ou aceda ao separador Encomendas na aplicação. Se ainda não encontrar, contacte o restaurante diretamente.',
  },
  pickup_instructions: {
    header: 'Onde levanto a minha encomenda?',
    body: 'As instruções de recolha são apresentadas no ecrã de confirmação e no resumo da encomenda. Procure a sinalização ou pergunte aos funcionários à chegada.',
  },
  loyalty_points: {
    header: 'Posso ganhar pontos de fidelidade com as minhas encomendas?',
    body: 'Sim, as compras elegíveis acumulam pontos automaticamente. Pode ver o seu saldo e recompensas no ecrã principal da aplicação.',
  },
  apply_promo_code: {
    header: 'Como aplico um código promocional ou desconto?',
    body: 'Durante o checkout, verá uma opção para introduzir um código promocional. Os descontos disponíveis também são aplicados automaticamente se for elegível.',
  },
  issue_with_order: {
    header: 'O que devo fazer se houver um problema com a minha encomenda?',
    body: 'Estamos aqui para ajudar. Contacte o restaurante através da aplicação ou envie um email de suporte usando a opção Contactar Suporte.',
  },
  use_loyalty_and_coupon: {
    header: 'Posso usar pontos de fidelidade e um cupão (como Compre 1 Leve 2) na mesma encomenda?',
    body: 'Não — apenas um desconto ou oferta pode ser aplicado por encomenda. Isto garante uma utilização justa das recompensas e promoções. Escolha a opção que lhe dá mais vantagem!',
  },
};
